import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=5bfadb2b&"
import script from "./settlement.vue?vue&type=script&lang=ts&"
export * from "./settlement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports